(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbMsgBusModule", [], factory);
	else if(typeof exports === 'object')
		exports["sbMsgBusModule"] = factory();
	else
		root["sbMsgBusModule"] = factory();
})(window, function() {
return 